<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
    >
        <div class="wrapBox">
            <el-form ref="formData" :model="formData" label-width="180px" size="mini">
                <div class="top">
                    <div style="font-weight: 900;">下载模板</div>
                    <div>
                        <a href="/export/产品负责人模板.xlsx"
                           style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“产品负责人模板”模板</a>
                    </div>
                </div>
                <div class="download">
                    <el-upload
                        class="upload-demo"
                        drag
                        action="/"
                        accept=".xls, .xlsx"
                        ref="upload"
                        :file-list="files"
                        :http-request="handleUpload"
                        :on-exceed='handExceed'
                        :on-remove="handleRemove"
                        :auto-upload="false"
                        :limit="1"
                        multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__text" style="font-size: 12px;margin-top: 5px;">只能上传.xls/.xlsx文件
                        </div>
                    </el-upload>
                </div>
            </el-form>
            <el-row class="bottomBox">
                <el-button
                    style="float:right;margin-left:6px;"
                    size="mini"
                    type="danger"
                    plain
                    @click="handleClose()"
                >取 消
                </el-button>
                <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')">确定
                </el-button>
            </el-row>
        </div>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import {manager_build_selection_add, manager_index_get_category_message} from '@/api/advAnalys/advAnalys.js'

    export default {
        data() {
            return {
                files: [],
                formData: {
                    remark: '',
                },
            }
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
        },
        methods: {
            handleUpload(raw) {
                this.files.push(raw.file)
            },
            handExceed(files, fileList) {
                this.$message({
                    type: 'warning',
                    message: `当前限制选择 1 个文件，共选择了 ${files.length +
                    fileList.length} 个文件.`
                })
                return
            },
            handFileSuccess() {
                this.files = []
                this.$refs.upload.clearFiles()
            },
            handleRemove(file, fileList) {
                this.files = fileList
            },
            // 保存信息
            // 保存信息
            submitForm(formData) {
                this.$refs[formData].validate(valid => {
                    if (valid) {
                        this.$refs.upload.submit() // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
                        if (this.files.length == 0) {
                            this.$message.warning(`当前限制只能上传选择 1 个文件`)
                            return
                        }
                        let file = new FormData()
                        file.append('file', this.files[0])
                        this.loading = true
                        api.logistics_asin_supervisor_upload(file).then(res => {
                            if (res.code === 0) {
                                this.loading = false
                                this.$message({
                                    type: 'success',
                                    message: '上传成功'
                                })
                                this.handleClose(true)
                            } else {
                                this.loading = false
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                })
                            }
                        })
                            .catch(() => {
                                this.loading = false
                                this.$message({
                                    type: 'error',
                                    message:
                                        '网络出现问题，请查看数据是否添加完成！'
                                })
                            })
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },
            // 关闭弹窗
            handleClose(isshow) {
                this.files = []
                this.formData = {
                    remark: '',
                }
                this.$emit('close-callback', isshow)
                this.disabled = false
            }
        }
    }
</script>
<style type="text/scss" lang="scss">
    .wrapBox {
        width: 600px;
        margin-top: 10px;

        .bottomBox {
            margin-top: 17px;
            display: flex;
            justify-content: center;
        }
    }

    .download {
        display: flex;
        justify-content: center;
    }

    .top {
        margin: 0px auto 20px;
        width: 60%;
        display: flex;
        justify-content: space-between;
    }
</style>
